import { render, staticRenderFns } from "./Note.vue?vue&type=template&id=6c0e2b72"
var script = {}
import style0 from "./Note.vue?vue&type=style&index=0&id=6c0e2b72&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports